import { render, staticRenderFns } from "./ReadyToFile.vue?vue&type=template&id=bec82266&scoped=true&"
import script from "./ReadyToFile.vue?vue&type=script&lang=js&"
export * from "./ReadyToFile.vue?vue&type=script&lang=js&"
import style0 from "./ReadyToFile.vue?vue&type=style&index=0&id=bec82266&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bec82266",
  null
  
)

export default component.exports